module.exports = __webpack_public_path__ + "static/media/logout.961342c0.svg";